export default __webpack_public_path__ + "images/a04a0316fdd7d7cd061edf3b541d3d30-adoption-dog-670.gif";